import Vue from 'vue'

import {
  CHANGEFROMURL,
  RECORD_USERINFO,
} from './mutation-types.js'

import {
  setStore,
  getStore
} from '../util/util'

export default {
  [CHANGEFROMURL](state,info){
    state.fromurl=info;
    state.login=true;
  },

  // 记录用户信息
  [RECORD_USERINFO](state, info) {

  },
  
}



// WEBPACK FOOTER //
// ./src/store/mutations.js